import styled from 'styled-components/macro';
import {
  fontSize,
  fontWeight,
  lineHeight,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';
import * as common from '../../common/elements/Form';
import * as StaffCommon from '../../common/elements/Staff';

export const Warning = styled.section`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 95%;
  /* keep the modal on screen on short phones */
  max-height: calc(100vh - ${space[6]});
  overflow-y: auto;
  background: ${({ theme }) => theme.appBackground};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.lg};
  ${common.ModalScreenWidthMQs}
`;

export const SaveChangesFooterRow = styled(StaffCommon.StaffFooterRow)`
  margin: 0;
  padding: ${space[4]};
  font-size: ${fontSize.md};
  border: none;
`;

export const SaveChangesMessage = styled.p`
  white-space: pre-line;
  text-align: center;
  margin: ${space[5]} ${space[4]} ${space[2]};
  font-size: ${fontSize.lg};
  font-weight: ${fontWeight.bold};
  line-height: ${lineHeight.normal};
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.headerColour};
`;

export const DiscardChangesButton = styled(
  common.Button
).attrs(({ $variant }) => ({ $variant: $variant || 'create' }))``;

export const GoBackButton = styled(common.Button).attrs(({ $variant }) => ({
  $variant: $variant || 'danger',
}))``;

export const AlertButton = styled(common.Button).attrs(
  ({ $variant, isWarning }) => ({
    $variant: $variant || (isWarning ? 'danger' : 'create'),
  })
)``;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
